export const INITIAL_VERSION = "v1.0.0";

export const LATEST_VERSION = "latest";
